export default __webpack_public_path__ + "static/media/video1.f747e942.mp4";